import Layout from "@/views/layout";

const stock = {
  path: "/stock",
  name: "Stock",
  component: Layout,
  meta: { title: "进货模块" },
  children: [
    {
      path: "stockList",
      name: "stockList",
      component: () => import("@/views/stock/stockList.vue"),
      meta: { title: "进货报表" }
    },
  ]
};

export default stock;
